








import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class InputTextArea extends Vue {
  @Prop(String) readonly value!: string
}
